document.addEventListener('DOMContentLoaded', function() {
  // Check if a product form exists on the page
  if (document.querySelector('.product-form')) {
    // Select the sticky add to cart element and the original product form
    const stickyAddToCart = document.querySelector('.sticky-add-to-cart');
    const productForm = document.querySelector('.product-form');
    
    // Add a scroll event listener to control the visibility of the sticky bar
    window.addEventListener('scroll', function() {
      // Get the position of the original product form relative to the viewport
      const formPosition = productForm.getBoundingClientRect().top;
      
      // If the form is scrolled up (position is negative), show the sticky bar
      if (formPosition < 0) {
        stickyAddToCart.style.display = 'block';
      } else {
        // If the form is still in view, hide the sticky bar
        stickyAddToCart.style.display = 'none';
      }
    });
  }
});